 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"chunk-0a060a31":"55c90b17","chunk-2d0d3105":"80254b00","chunk-76d23d3e":"aa69d7bf","chunk-00eb12a9":"684607e3","chunk-228ba294":"89e0ca0c","chunk-fe066d14":"fcf8929d","chunk-27aa7f83":"c59cc4ce","chunk-2d018bd0":"dcc9816f","chunk-234d3534":"1135bfef","chunk-74da50f5":"3eeba54e","chunk-55aabd18":"d4c6806a","chunk-fb85e650":"9ecaf8c5","chunk-49770dd0":"c8ef8eff","chunk-2d0a32e5":"e700c079","chunk-7fbdf37c":"330c9831","chunk-332c59c2":"4d6b00b1","chunk-1512f34e":"d63e73a5","chunk-75888906":"e301aab5","chunk-7b89d3a3":"986ade8c","chunk-702af04d":"99933da2","chunk-7d06d798":"465bb526","chunk-861b25a8":"225b13bf","chunk-2b53318a":"77b577a3","chunk-335d518b":"34e119e7","chunk-589a1ed8":"23fa7986","chunk-d7b02cc8":"a712f720","chunk-77268961":"2d74ded1","chunk-011dec2a":"5fded762","chunk-1c624656":"1000cfa7","chunk-7855156a":"ca53ba8e","chunk-09152acd":"c2ec3e06","chunk-2f2e0cee":"ff597839","chunk-70c6ad3c":"5b087f5f","chunk-d0ea16de":"90426fcd","chunk-655cd230":"68875a6a","chunk-63abd516":"f716a1c0","chunk-2d0cf703":"1a617e5c","chunk-2a455697":"f9216167","chunk-f6349c62":"1a0f2ad4","chunk-2d207975":"f077e3bc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0a060a31":1,"chunk-76d23d3e":1,"chunk-00eb12a9":1,"chunk-fe066d14":1,"chunk-27aa7f83":1,"chunk-2d018bd0":1,"chunk-234d3534":1,"chunk-74da50f5":1,"chunk-55aabd18":1,"chunk-fb85e650":1,"chunk-49770dd0":1,"chunk-7fbdf37c":1,"chunk-332c59c2":1,"chunk-1512f34e":1,"chunk-75888906":1,"chunk-7b89d3a3":1,"chunk-702af04d":1,"chunk-7d06d798":1,"chunk-2b53318a":1,"chunk-335d518b":1,"chunk-589a1ed8":1,"chunk-d7b02cc8":1,"chunk-77268961":1,"chunk-011dec2a":1,"chunk-1c624656":1,"chunk-7855156a":1,"chunk-09152acd":1,"chunk-2f2e0cee":1,"chunk-70c6ad3c":1,"chunk-d0ea16de":1,"chunk-655cd230":1,"chunk-63abd516":1,"chunk-2a455697":1,"chunk-f6349c62":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({}[chunkId]||chunkId) + "." + {"chunk-0a060a31":"e3e411bc","chunk-2d0d3105":"31d6cfe0","chunk-76d23d3e":"d64ca0e5","chunk-00eb12a9":"27ef2889","chunk-228ba294":"31d6cfe0","chunk-fe066d14":"793c3ef7","chunk-27aa7f83":"da7ec1ee","chunk-2d018bd0":"a3604173","chunk-234d3534":"b9ba8705","chunk-74da50f5":"3f474139","chunk-55aabd18":"88de1684","chunk-fb85e650":"05e7b577","chunk-49770dd0":"3948dc5e","chunk-2d0a32e5":"31d6cfe0","chunk-7fbdf37c":"6bf27c8f","chunk-332c59c2":"6333a4f8","chunk-1512f34e":"b90da0c5","chunk-75888906":"30664ff0","chunk-7b89d3a3":"3f474139","chunk-702af04d":"39213d4e","chunk-7d06d798":"a58f65b9","chunk-861b25a8":"31d6cfe0","chunk-2b53318a":"b7149291","chunk-335d518b":"db9217d6","chunk-589a1ed8":"bfa68e35","chunk-d7b02cc8":"d3f3db62","chunk-77268961":"a2cc3a26","chunk-011dec2a":"cebd3211","chunk-1c624656":"229bce66","chunk-7855156a":"7cbd00d4","chunk-09152acd":"64449b04","chunk-2f2e0cee":"82e02ac1","chunk-70c6ad3c":"9ccb8757","chunk-d0ea16de":"7cbd00d4","chunk-655cd230":"82d9f164","chunk-63abd516":"8971780f","chunk-2d0cf703":"31d6cfe0","chunk-2a455697":"e5fab241","chunk-f6349c62":"0a9dd7b0","chunk-2d207975":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://s1.zhuanstatic.com/open/ZZGameActivity/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["chunk-76d23d3e"]]);
 	return startupResult;
